import * as Sentry from '@sentry/browser'

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_FE_DSN,
  allowUrls: [
    import.meta.env.VITE_DOMAIN,
    import.meta.env.VITE_CLOUDFRONT_ENDPOINT
  ],
  release: import.meta.env.VITE_GIT_SHA,
  environment: import.meta.env.VITE_SENTRY_ENV,
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: 0.25
})

const meta = document.querySelector('meta[name=user_id]')
if (meta instanceof HTMLMetaElement && meta.content) {
  Sentry.setUser({ id: meta.content })
}
